import { ref } from "vue";

export const airborneOnly = ref(false);
export const searchTerm = ref("");
export const insuredOnly = ref(true);

export const resetFilters = () => {
	airborneOnly.value = false;
	searchTerm.value = "";
	insuredOnly.value = true;
};


export const excludedBrokerages = ref<string[]>([]);